
  export default {
    mounted() {
      this.wasConnected = true;
    },
    disconnected() {
      if (this.wasConnected) {
        this.disconnectTimer = setTimeout(() => {
          this.el.removeAttribute("hidden");
        }, 300);
      }
    },
    reconnected() {
      clearTimeout(this.disconnectTimer);
      this.el.setAttribute("hidden", "");
    }
  }
